import { Router } from '@angular/router';
import { Auth } from '../auth.service';
import { Component } from '@angular/core';

@Component({
  templateUrl: 'login.component.html'
})

export class LoginComponent {
  loginError: boolean;
  email: string;
  password: string;

  constructor(public auth: Auth, public router: Router) {
  }

  login() {
    this.loginError = false;
    this.auth.login(this.email, this.password)
      .subscribe(
        (result) => {
          this.router.navigate(['/']);
        }, (err) => {
          this.loginError = true;
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.ts